<div
  [ngStyle]="backgroundStyle()"
  class="rounded-(--infolistcard-border-radius) overflow-hidden font-(family-name:--infolistcard-font-family)"
  [ngClass]="{ 'border border-solid border-(--infolistcard-outer-border-color)': config().showBorder }"
>
  @for (item of config().items; track $index; let isLast = $last) {
    <div
      [class]="
        'flex gap-(--infolistcard-gap) items-start px-(--infolistcard-padding-x) py-(--infolistcard-padding-y) ' +
        (isLast ? '' : 'border-b border-(--infolistcard-border-color)')
      "
    >
      <div class="shrink-0 w-8 h-8 flex items-center justify-center">
        <app-dynamic
          componentName="SvgIcon"
          [props]="{
            name: item.icon,
            size: '32',
            color: config().iconColor,
            gradient: config().iconColor ? undefined : (config().iconGradient ?? 'primary'),
          }"
        />
      </div>
      <div class="flex flex-col gap-(--infolistcard-text-gap)">
        <app-dynamic
          componentName="DynamicText"
          [props]="{
            config: {
              text: item.title,
              size: 'xl',
              fontWeight: 'semibold',
              color: 'var(--infolistcard-title-color)',
            },
          }"
        />
        @for (desc of item.descriptions; track $index) {
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: desc,
                size: 'base',
                fontWeight: 'semibold',
                color: 'var(--infolistcard-description-color)',
              },
            }"
          />
        }
      </div>
    </div>
  }
</div>
